import React, { PropTypes } from 'react';
import YearPanel from '../year/YearPanel';
import MonthTable from './MonthTable';

function goYear(direction) {
  const next = this.state.value.clone();
  next.addYear(direction);
  this.setAndChangeValue(next);
}

function noop() {

}

const MonthPanel = React.createClass({
  propTypes: {
    onChange: PropTypes.func,
    disabledDate: PropTypes.func,
    onSelect: PropTypes.func,
  },

  getDefaultProps() {
    return {
      onChange: noop,
      onSelect: noop,
    };
  },

  getInitialState() {
    const props = this.props;
    // bind methods
    this.nextYear = goYear.bind(this, 1);
    this.previousYear = goYear.bind(this, -1);
    this.prefixCls = `${props.rootPrefixCls}-month-panel`;
    return {
      value: props.value || props.defaultValue,
    };
  },

  componentWillReceiveProps(nextProps) {
    if ('value' in nextProps) {
      this.setState({
        value: nextProps.value,
      });
    }
  },

  onYearPanelSelect(current) {
    this.setState({
      showYearPanel: 0,
    });
    this.setAndChangeValue(current);
  },


  setAndChangeValue(value) {
    this.setValue(value);
    this.props.onChange(value);
  },

  setAndSelectValue(value) {
    this.setValue(value);
    this.props.onSelect(value);
  },

  setValue(value) {
    if (!('value' in this.props)) {
      this.setState({
        value,
      });
    }
  },

  showYearPanel() {
    this.setState({
      showYearPanel: 1,
    });
  },

  render() {
    const props = this.props;
    const value = this.state.value;
    const locale = props.locale;
    const year = value.getYear();
    const prefixCls = this.prefixCls;
    let yearPanel;
    if (this.state.showYearPanel) {
      yearPanel = (<YearPanel
        locale={locale}
        value={value}
        rootPrefixCls={props.rootPrefixCls}
        onSelect={this.onYearPanelSelect}
      />);
    }
    return (
      <div className={prefixCls} style={props.style}>
        <div>
          <div className={`${prefixCls}-header`}>
            <a
              className={`${prefixCls}-prev-year-btn`}
              role="button"
              onClick={this.previousYear}
              title={locale.previousYear}
            >
              «
            </a>

            <a
              className={`${prefixCls}-year-select`}
              role="button"
              onClick={() => {
                  if (this.props.onYearSelectHandler) {
                    this.props.onYearSelectHandler(this.state.value.getYear())
                  } else {
                    this.showYearPanel()
                  }
                }
              }
              title={locale.yearSelect}
            >
              <span className={`${prefixCls}-year-select-content`}>{year}</span>
              <span className={`${prefixCls}-year-select-arrow`}>x</span>
            </a>

            <a
              className={`${prefixCls}-next-year-btn`}
              role="button"
              onClick={this.nextYear}
              title={locale.nextYear}
            >
              »
            </a>
          </div>
          <div className={`${prefixCls}-body`}>
            <MonthTable
              disabledDate={props.disabledDate}
              onSelect={this.setAndSelectValue}
              locale={locale}
              value={value}
              prefixCls={prefixCls}
              redDots={props.redDots}
              year={year}
            />
          </div>
        </div>
        {yearPanel}
      </div>);
  },
});

export default MonthPanel;



// WEBPACK FOOTER //
// ./_rc-calendar-5.6.2/src/month/MonthPanel.jsx